import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  TextField,
  useMediaQuery,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Paper,
  Avatar,
  Chip,
  DialogActions,
  Tooltip,
  TablePagination,
  CircularProgress,
  Link,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { KeyboardArrowRight, Circle } from "@mui/icons-material";

function JobsLinkedinIndeed() {
  const location = useLocation();
  const isPublicResultRoute = location.pathname.includes("/public-result");

  // Get data from appropriate reducer based on route
  const publicResult = useSelector(
    (state) => state?.ResultReducer?.publicResult || {}
  );
  const oldFormReducer = useSelector(
    (state) => state?.OldFormReducer || {}
  );

  // Determine which data source to use
  const resultData = isPublicResultRoute
    ? publicResult || {}
    : oldFormReducer;
  const [jobLocation, setJobLocation] = useState();
  const [indeedUrl, setIndeedUrl] = useState(
    isPublicResultRoute
      ? publicResult?.results?.countryCode?.indeedUrl || publicResult?.userData?.results?.countryCode?.indeedUrl
      : resultData?.results?.countryCode?.indeedUrl
  );
  const [monthlySalary, setMonthlySalary] = useState();

  function extractCityState() {
    let locationString = isPublicResultRoute
      ? publicResult?.userData?.location || publicResult?.location
      : resultData?.userData?.location || resultData?.location;
    if (locationString) {
      // Find the index of the last comma
      let lastIndex = locationString.lastIndexOf(",");
      // Extract the substring up to the last comma
      let result = locationString.substring(0, lastIndex);
      setJobLocation(result);
    }
  }

  const formatCurrencyString = (str) => {
    const symbolFirst = /^[^\d]+/;
    const symbolLast = /[^\d]+$/;

    if (symbolFirst.test(str)) {
      return str;
    } else if (symbolLast.test(str)) {
      const parts = str.split(symbolLast);
      const number = parts[0].trim();
      const symbol = str.match(symbolLast)[0].trim();
      return `${symbol}${number}`;
    } else {
      return str;
    }
  };
  console.log(monthlySalary, "monthlySalary");
  console.log(resultData, "resultData");
  function convertCurrency() {
    const results = isPublicResultRoute
      ? publicResult?.results || publicResult?.userData?.results
      : resultData?.results;
    if (!results) return;
    const { marketSalary, countryCode, convertedMarketSalary } = results;

    // const currency = new Intl.NumberFormat(countryCode?.languageCode, {
    //   style: "currency",
    //   currency: countryCode?.code,
    //   maximumSignificantDigits: 4,
    // });
    // console.log(currency.format(convertedMarketSalary), "currency");
    setMonthlySalary(formatCurrencyString(convertedMarketSalary));
  }
  useEffect(() => {
    convertCurrency();
    extractCityState();
  }, [resultData, publicResult, isPublicResultRoute]);

  return (
    <>
      <Box sx={{ px: { xs: 2, sm: 3, md: 10 } }}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              sx={{
                borderRadius: "20px",
                // boxShadow: "0px 0px 4px 0px #CDCAC073",
                border: "1.5px solid #8DE49A",
                background: "#F1FFF4",
                // height: "100%",
                boxSizing: "inherit",
                py: 2,
                px: 3,
                minWidth: { xs: "100%", md: "100%", lg: "70%" },
                // mb: "20px !important",
              }}
              className={"find-jobs-container"}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: { xs: "12px", sm: "12px", md: "18px" },
                }}
              >
                Jobs that best fit your expertise and TechValue
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "center",
                  mt: "10px",
                  gap: 2,
                }}
              >
                <Link
                  sx={{
                    maxWidth: {
                      xs: "130px",
                      sm: "13 0px",
                      md: "180px",
                    },
                    width: "100%",
                    display: "inline-flex",
                    gap: "4px",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: { xs: "13px", sm: "13px", md: "16px" },
                    fontWeight: 500,
                    backgroundColor: "rgba(43, 179, 68, 0.1)",
                    color: "#2BB344",
                    // border: "2px solidrgb(23, 29, 24)",
                    p: "8px 12px",
                    borderRadius: "10px",
                    textDecoration: "none",
                    // "&:hover": {
                    //   backgroundColor: "#0D9B21 !important",
                    //   color: "#fff",
                    //   borderColor: "#fff",
                    // },
                  }}
                  target="_blank"
                  href={`https://www.linkedin.com/jobs/search/?currentJobId=3788215852&f_TPR=r604800&keywords=${
                    resultData?.topSkills
                      ? resultData?.topSkills[0]["name"]
                      : ""
                  }&location=${jobLocation}&origin=JOB_SEARCH_PAGE_JOB_FILTER`}
                >
                  <img
                    src="../../../assets/images/linkedin-square.png"
                    alt="Linkedin"
                    width="20px"
                    loading="lazy"
                  />
                  Linkedin
                  <KeyboardArrowRight />{" "}
                </Link>{" "}
                <Link
                  sx={{
                    maxWidth: { xs: "130px", sm: "130px", md: "180px" },
                    width: "100%",
                    display: "inline-flex",
                    gap: "4px",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: { xs: "13px", sm: "13px", md: "16px" },
                    fontWeight: 500,
                    backgroundColor: "rgba(43, 179, 68, 0.1)",
                    color: "#2BB344",
                    // border: "2px solid #2BB344",
                    p: "8px 12px",
                    borderRadius: "10px",
                    textDecoration: "none",
                    // "&:hover": {
                    //   backgroundColor: "#0D9B21 !important",
                    //   color: "#fff",
                    //   borderColor: "#0D9B21",
                    // },
                  }}
                  target="_blank"
                  href={`${indeedUrl}/jobs?q=${
                    resultData?.userData?.relevanceResult
                      ? resultData?.userData?.relevanceResult[0]["name"]
                      : ""
                  }&l=${jobLocation}`}
                >
                  <img
                    src="../../../assets/images/indeed.png"
                    alt="Indeed"
                    width="20px"
                    loading="lazy"
                  />
                  Indeed
                  <KeyboardArrowRight />{" "}
                </Link>{" "}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Box>
    </>
  );
}

export default JobsLinkedinIndeed;
